import "../CSS/Ploeg.css";

function U6() {
  return (
    <div className="ploegoverzicht">
      <iframe
        className="klassement"
        src="https://www.voetbalvlaanderen.be/competitie/CHP_126411/overzicht"
      />
    </div>
  );
}

export default U6;
